// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__TXky4","title":"styles_title__XW2gT"};